export default __webpack_public_path__ + "static/media/Dq.ca445001.png";